export const ADD_TEMPLATE_RESET = 'ADD_TEMPLATE_RESET';
export const ADD_TEMPLATE_REQUEST = 'ADD_TEMPLATE_REQUEST';
export const ADD_TEMPLATE_REQUEST_COMPLETED = 'ADD_TEMPLATE_REQUEST_COMPLETED';
export const ADD_TEMPLATE_REQUEST_ERROR = 'ADD_TEMPLATE_REQUEST_ERROR';

export const EDIT_TEMPLATE_RESET = 'EDIT_TEMPLATE_RESET';
export const EDIT_TEMPLATE_REQUEST = 'EDIT_TEMPLATE_REQUEST';
export const EDIT_TEMPLATE_REQUEST_COMPLETED = 'EDIT_TEMPLATE_REQUEST_COMPLETED';
export const EDIT_TEMPLATE_REQUEST_ERROR = 'EDIT_TEMPLATE_REQUEST_ERROR';

export const FETCH_TEMPLATE_REQUEST = 'FETCH_TEMPLATE_REQUEST';
export const FETCH_TEMPLATE_REQUEST_COMPLETED = 'FETCH_TEMPLATE_REQUEST_COMPLETED';
export const FETCH_TEMPLATE_REQUEST_ERROR = 'FETCH_TEMPLATE_REQUEST_ERROR';
export const FETCH_TEMPLATE_RESET = 'FETCH_TEMPLATE_RESET';

export const FETCH_TEMPLATE_LIST_REQUEST = 'FETCH_TEMPLATE_LIST_REQUEST';
export const FETCH_TEMPLATE_LIST_REQUEST_COMPLETED = 'FETCH_TEMPLATE_LIST_REQUEST_COMPLETED';
export const FETCH_TEMPLATE_LIST_REQUEST_ERROR = 'FETCH_TEMPLATE_LIST_REQUEST_ERROR';

export const FETCH_SWITCH_TEMPLATE_LIST_REQUEST = 'FETCH_SWITCH_TEMPLATE_LIST_REQUEST';
export const FETCH_SWITCH_TEMPLATE_LIST_REQUEST_COMPLETED = 'FETCH_SWITCH_TEMPLATE_LIST_REQUEST_COMPLETED';
export const FETCH_SWITCH_TEMPLATE_LIST_REQUEST_ERROR = 'FETCH_SWITCH_TEMPLATE_LIST_REQUEST_ERROR';




// WEBPACK FOOTER //
// ./constants/templatedetails.js